/**
 * @fileoverview GET handler for the "/engagement/audience_sync/:platform/ad_accounts" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementAudienceSyncPlatformAdAccounts } from "./constants";
import type { EngagementAudienceSyncPlatformAdAccountsResult } from "./types";

export const getEngagementAudienceSyncPlatformAdAccounts = reactQueryFetcherAdapter(
  engagementAudienceSyncPlatformAdAccounts,
  (signal: AbortSignal, platform: string): Promise<EngagementAudienceSyncPlatformAdAccountsResult> => {
    return fetch(
      `/engagement/audience_sync/${platform}/ad_accounts`,
      "GET",
      {},
      { signal },
      { propagateFetchRequestError: false }
    );
  }
);
